
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { NolimitPlugin } from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import { GameFlowController } from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import { LogLevel } from '@nolimitcity/slot-launcher/bin/utils/Logger';
import { FlowState } from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { AssetsConfig } from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import { ResourcesGroupName } from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import { BaseModel } from "./server/data/BaseModel";
import { Background } from "./background/Background";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";

import { FeatureFlow } from "./presentations/normal/FeatureFlow";
import { RespinPresentation } from "./presentations/normal/RespinPresentation";
import { NormalStartPresentation } from "./presentations/normal/NormalStartPresentation";
import { NormalIdlePresentation } from "./presentations/normal/NormalIdlePresentation";
import { NormalStopPresentation } from "./presentations/normal/NormalStopPresentation";
import { NormalStoppedPresentation } from "./presentations/normal/NormalStoppedPresentation";
import { BonusIntroPresentation } from "./presentations/normal/BonusIntroPresentation";
import { NormalWinPresentation } from "./presentations/normal/NormalWinPresentation";
import { NormalBigWinPresentation } from "./presentations/normal/NormalBigWinPresentation";

import { BrokeTheBankPresentation } from "./presentations/general/BrokeTheBankPresentation";

import { SetupFlow } from "./presentations/setup/SetupFlow";
import { SetupRestoreIntro } from "./presentations/setup/SetupRestoreIntro";
import { SetupRestoreFlow } from "./presentations/setup/SetupRestoreFlow";
import { SetupRestoreSummary } from "./presentations/setup/SetupRestoreSummary";
import { SetupStopPresentation } from "./presentations/setup/SetupStopPresentation";


import { RespinStopPresentation } from "./presentations/respin/RespinStopPresentation";
import { RespinStoppedPresentation } from "./presentations/respin/RespinStoppedPresentation";

import { FSRestore } from "./presentations/freespin/FSRestore";
import { FSIdlePresentation } from "./presentations/freespin/FSIdlePresentation";
import { FSOutroPresentation } from "./presentations/freespin/FSOutroPresentation";

import { GameAssets } from "./config/texture/GameAssets";
import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import { RoadRageEngineManager } from "./reel/RoadRageEngineManager";

import { RoadRageSymbolData } from "./reel/symbol/RoadRageSymbolData";
import { GameConfig } from "./config/base/GameConfig";

import { PresentationController } from "../dev/gameflow/controller/PresentationController";
import { PresentationManager } from "../dev/gameflow/controller/PresentationManager";
import { GameSetting } from "../dev/setting/GameSetting";
import { Translator } from "../dev/setting/Translator";

import { RoadRageCounter } from "./independent/countup/RoadRageCounter";

import { ISymbolValues, MiniPayTable } from "../dev/extra/MiniPayTable";
import { TestTool } from "../dev/debug/DataChecker/Internal/TestTool";

import { PosterManager } from "./independent/poster/PosterManager";
import { ParticlesManager } from "./independent/particles/ParticlesManager";

import { Speedster } from "../dev/debug/Speedster"
import { OverlayAnimation } from "./independent/animations/OverlayAnimation";
import { BonusCounters } from "./independent/countup/BonusCounters";

import { SplashController } from "./independent/splashScreen/SplashController";

import { UniversalPlayer } from "../dev/displayobject/UniversalPlayer";
import { InitData } from "./server/data/BaseModel";
import { BackgroundOverlay } from './background/BackgroundOverlay';
import { RoadRageReelOverlay } from './reel/RoadRageReelOverlay';
import { FSStopPresentation } from './presentations/freespin/FSStopPresentation';
import { FSStartPresentation } from './presentations/freespin/FSStartPresentation';
import { SetupSummary } from './presentations/setup/SetupSummary';
import { MysteryPresentation } from './presentations/normal/MysteryPresentation';
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";

export class RoadRage extends SlotGame {

    public static  WIN_BELOW_STAKE: boolean = false;

    public static model: BaseModel;
    public static assetLoader: AssetLoader;

    private static symbolData: RoadRageSymbolData;
    private static gameFlowController: GameFlowController;
    private static presentationManager: PresentationManager;

    public static backgroundElements: Background;

    public static particleManager: ParticlesManager;

    public static gameSetting: GameSetting;
    public static translate: Translator;
    public static counter: RoadRageCounter;
    public static overlayAnim: OverlayAnimation;
    public static bgOverlay: BackgroundOverlay;

    public static reelManager: RoadRageEngineManager;

    public static poster: PosterManager;

    constructor() {
        super();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M5",
                    "L3",
                    "M5",
                    "L4",
                    "L5"
                ],
                [
                    "L2",
                    "L5",
                    "L3",
                    "M2",
                    "L4"
                ],
                [
                    "L1",
                    "M5",
                    "L4",
                    "M1",
                    "M4"
                ],
                [
                    "L2",
                    "L4",
                    "L2",
                    "L2",
                    "L3"
                ],
                [
                    "L4",
                    "M1",
                    "L2",
                    "M3",
                    "M5"
                ]
            ],
            "evaluatedArea": [
                [
                    "L3",
                    "M5",
                    "L4"
                ],
                [
                    "L5",
                    "L3",
                    "M2"
                ],
                [
                    "M5",
                    "L4",
                    "M1"
                ],
                [
                    "L4",
                    "L2",
                    "L2"
                ],
                [
                    "M1",
                    "L2",
                    "M3"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinTriggeredThisSpin": false,
            "symbolSizes": [
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ]
            ],
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "scatterReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "fsInfo": {}
        };
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {

            RoadRage.translate = new Translator(RoadRage.apiPlugin.translations.translate);
            RoadRage.gameSetting = new GameSetting(RoadRage.apiPlugin);
            RoadRage.model = new BaseModel(RoadRage.apiPlugin);
            RoadRage.model.logger.level = LogLevel.DEV;

            AssetsConfig.addToAssetsConfig(GameAssets.RESOURCES_GROUPS);

            RoadRage.gameFlowController = new GameFlowController(RoadRage.apiPlugin, RoadRage.model);
            RoadRage.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            RoadRage.presentationManager = new PresentationManager(RoadRage.model);

        // General
           const resultNormal = new NormalWinPresentation();
           const resulBigWinNormal = new NormalBigWinPresentation();
           const bonusIntro = new BonusIntroPresentation();
           const brokeTheBank = new BrokeTheBankPresentation();

            // Normal
            const startNormal = new NormalStartPresentation();
            const stopNormal = new NormalStopPresentation();
            const stoppedNormal = new NormalStoppedPresentation();
            const featureFlow = new FeatureFlow();
            const idleNormal = new NormalIdlePresentation();
            const respinPres = new RespinPresentation();

            // Respin
            const respinStop = new RespinStopPresentation();
            const respinStopped = new RespinStoppedPresentation();

            // Setup
            const setupStop = new SetupStopPresentation();
            const setupRestoreFlow = new SetupRestoreFlow();
            const setupRestoreIntro = new SetupRestoreIntro();
            const setupRestoreSummary = new SetupRestoreSummary()
            const setupSum = new SetupSummary();
            
            const setupFlow = new SetupFlow();
           
            // FS
            const idleFs = new FSIdlePresentation();
            const restoreFS = new FSRestore();
            const startFS = new FSStartPresentation();
            const stopFS = new FSStopPresentation();
            const mystPres = new MysteryPresentation();

            RoadRage.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, RoadRage.presentationManager.addController([
                    setupRestoreIntro, // Using Poster
                    idleNormal
                ],GameMode.NORMAL)],

                [FlowState.BET, RoadRage.presentationManager.addController([
                    startNormal
                ],GameMode.NORMAL)],

                [FlowState.RESULT, RoadRage.presentationManager.addController([
                    stopNormal,
                    stoppedNormal,
                    featureFlow,
                    mystPres
                ],GameMode.NORMAL)],

                [FlowState.WIN, RoadRage.presentationManager.addController([
                    resultNormal,
                    resulBigWinNormal,
                    respinPres,
                    bonusIntro,
                    brokeTheBank
                ],GameMode.NORMAL)],
            ]));

            RoadRage.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, RoadRage.presentationManager.addController([
                    // restoreFS,
                    idleFs
                ],GameMode.RESPIN)],
                [FlowState.BET, RoadRage.presentationManager.addController([
                    startNormal
                ],GameMode.RESPIN)],
                [FlowState.RESULT, RoadRage.presentationManager.addController([
                    respinStop,
                    respinStopped,
                    featureFlow,
                    mystPres
                ],GameMode.RESPIN)],

                [FlowState.WIN, RoadRage.presentationManager.addController([
                    resultNormal,
                    resulBigWinNormal,
                    brokeTheBank
                ],GameMode.RESPIN)],
            ]));
            
            RoadRage.gameFlowController.addGameModeFlowStatePresentationMap("FREESPIN_SETUP", new Map<FlowState, PresentationController>([
                [FlowState.IDLE, RoadRage.presentationManager.addController([
                    setupRestoreIntro, // Using Poster
                    setupRestoreFlow,
                    setupRestoreSummary, 
                    idleFs // Trigger zero Bet
                ],"FREESPIN_SETUP")],
                [FlowState.BET, RoadRage.presentationManager.addController([
                    startFS
                ],"FREESPIN_SETUP")],
                [FlowState.RESULT, RoadRage.presentationManager.addController([
                    setupStop,
                    setupFlow,
                    setupSum
                ],"FREESPIN_SETUP")],
                [FlowState.WIN, RoadRage.presentationManager.addController([],"FREESPIN_SETUP")],
            ]));
            
            RoadRage.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, PresentationController>([
                [FlowState.IDLE, RoadRage.presentationManager.addController([
                    setupRestoreIntro, // Using Poster
                    setupRestoreFlow,
                    setupRestoreSummary,
                    restoreFS,
                    idleFs
                ],GameMode.FREESPIN)],
                [FlowState.BET, RoadRage.presentationManager.addController([
                    startFS
                ],GameMode.FREESPIN)],
                [FlowState.RESULT, RoadRage.presentationManager.addController([
                    stopFS,
                    featureFlow,
                    mystPres
                ],GameMode.FREESPIN)],
                [FlowState.WIN, RoadRage.presentationManager.addController([
                    resultNormal,
                    resulBigWinNormal,
                    brokeTheBank,
                    bonusIntro,
                    new FSOutroPresentation()
                ],GameMode.FREESPIN)],
            ]));

            return value;
        });
    }

    public getPaytable(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(RoadRage.apiPlugin.resources.getStaticRoot());

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });
        let symbolDataValueData: ISymbolValues = RoadRage.model.initData.symbolValues;
        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Paytable" && asset.loadedData) {
                    for (let key in symbolDataValueData) {
                        // #477
                        let nameKey: string = key;
                        if (RoadRage.apiPlugin.gameClientConfiguration.useCensoredGfxUS && ["M3","L3"].findIndex(v => v == nameKey) >= 0) {
                            nameKey += "_blur";
                        }
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, RoadRage.getSymbolString(nameKey, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("KennethMustDie could not load Paytable");
        });
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5]}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4]}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3]}</span>
                </div>
            </div>
            </div>
        `;
    }



    // private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
    //     return `
    //     <div class="symbol">
    //         <img src="{{gamePath}}screens/images/symbols/${key}.png">
    //         <div class="payout-group">
    //             <div class="payout">
    //                 <span class="number">5</span>
    //                 <span class="multiplier" data-multiplier="3">3</span>
    //             </div>
    //             <div class="payout">
    //                 <span class="number">4</span>
    //                 <span class="multiplier" data-multiplier="0.5">0.5</span>
    //             </div>
    //             <div class="payout">
    //                 <span class="number">3</span>
    //                 <span class="multiplier" data-multiplier="0.35">0.35</span>
    //             </div>
    //         </div>
    //     </div>
    //     `;
    // }



    // Loading assets.
    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {
            RoadRage.assetLoader = new AssetLoader(RoadRage.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            const promises = Promise.all([fontLoader.load(), RoadRage.assetLoader.load(ResourcesGroupName.MAIN)]);

            // Assets have been loaded.
            return promises.then((values: any) => {

                UniversalPlayer.setLoader(RoadRage.assetLoader);
                
                (RoadRage.symbolData = new RoadRageSymbolData(RoadRage.assetLoader)).parseInitDataForInit(RoadRage.model.initData);

                RoadRage.presentationManager.initPresentations();

                this.createViewsAndComponents();

                return value;
            });
        });
    }

    // Everything loaded and ready.
    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            //Todo - restore ?
            return value;
        });
    }

    // Player presses the start button.
    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            RoadRage.gameFlowController.start();
            return value;
        });
    }

    private createViewsAndComponents() {

        if (GameSetting.isDevMode) {
            console.log(RoadRageSymbolData.getAllConfigs());
            this.addLayer(new Speedster())
            this.addLayer(new TestTool(RoadRage.model))
        }

        this.addLayer(new MiniPayTable((RoadRage.model.initData as InitData).symbolValues, { showBetValue: true }));

        RoadRage.counter = this.addLayer(new RoadRageCounter());
        RoadRage.particleManager = this.addLayer(new ParticlesManager(RoadRage.assetLoader));

        this.addLayer(new SplashController())
        RoadRage.poster = this.addLayer(new PosterManager());

        RoadRage.overlayAnim = this.addLayer(new OverlayAnimation());

        this.addLayer(new BonusCounters())
        
        RoadRage.bgOverlay = this.addLayer(new BackgroundOverlay());
        
        this.addLayer(new RoadRageReelOverlay())


        RoadRage.reelManager = this.addLayer(new RoadRageEngineManager(5,
            GameConfig.instance.REEL_ENGINE_CONFIG,
            RoadRage.model.initData.Reel,
            (value: number) => RoadRage.gameFlowController.calculatePaddingDuration(value)
        ));
        
        RoadRage.backgroundElements = this.addLayer(new Background());
    }

    private addLayer(layer:any):any{
        NolimitApplication.addLayerAt(layer.name, layer, 0);
        return layer;
    }
}